import classNames from 'classnames';
import React from 'react';
import { Form } from 'react-bootstrap';
import { PatternFormat } from 'react-number-format';
import { DisplayFieldType } from './types';
export interface IDisplayFieldProps extends React.HTMLAttributes<HTMLElement> {
	text?: string,
	value?: boolean | string | JSX.Element,
	type?: DisplayFieldType,
	textClass?: string,
	placeholder?: string,
}

export const DisplayField = ({ type = 'text', value, textClass, placeholder, ...props }: IDisplayFieldProps) => {
	switch (type) {
		case "tel":
			return <PatternFormat
				className='displayField phone'
				type={type}
				customInput={Form.Control}
				value={value ? String(value) : undefined}
				format="###-###-####"
				mask="_"
				readOnly
			/>
		case "checkbox":
			return <Form.Check
				type="checkbox"
				className="d-inline mx-2 ms-0 big-checkbox border-for-checkbox cursor-not-allowed"
				checked={(value as boolean)}
				disabled={true}
			/>
		case "text":
		default:
			return (<div {...props} className={classNames("display-field", textClass)}>{value ? value : (placeholder ? placeholder : "-")}</div>)
	}
}
